<template>
	<div class="credit-card">
		<div class="card-front">
			<card :color="type.color">
				<chip />
				<img class="card-brand" :src="type.image">
				<card-number :value="creditCard.cardNumber || '•••• •••• •••• ••••'"/>
				<labeled-info class="holder" :label="translation.sale.holder" :value="creditCard.holder || translation.sale.holderName"/>
				<labeled-info class="expiration-date" :label="translation.sale.dueDate" :value="creditCard.expirationDate || '00/00'"/>
			</card>
		</div>
		<div class="card-back">
			<card :back="true" :color="type.color">
				<div class="black-bar"></div>
				<div class="securityCode">{{creditCard.securityCode || '000'}}</div>
			</card>
		</div>
	</div>
</template>

<script>
import Card from './Card';
import Chip from './Chip';
import CardNumber from './CardNumber';
import LabeledInfo from './LabeledInfo';
import { translate } from '../../assets/translations';

export default {
	components: { Card, Chip, CardNumber, LabeledInfo },
	props: ['creditCard', 'type', 'language'],
	computed: {
    translation() {
      return translate(this.language);
    }
	}
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css?family=Source+Code+Pro&display=swap');

.credit-card {
	display: grid;
	grid-template-columns: [left] calc(323px * 1.1) [right] 80px;
	grid-template-rows: [top] calc(204px * 1.1) [bottom] 30px;
}

.card-front {
	grid-column: left;
	grid-row: top;
	z-index: 2;
}

.card.front {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto 50px 40px;
	grid-template-areas:
		'chip card-brand'
		'card-number card-number'
		'holder expiration-date';

	padding: 25px;
	text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.card-back {
	grid-column-start: left;
	grid-column-end: right;
	grid-row-start: top;
	grid-row-end: bottom;

	display: flex;
	justify-content: flex-end;
	align-items: flex-end;

	width: calc(323px * 1.1 + 80px);
	height: calc(204px * 1.1 + 30px);
}

.chip { grid-area: chip; }
.card-number { grid-area: card-number; }
.holder { grid-area: holder; }
.expiration-date {
	grid-area: expiration-date;
	align-items: flex-end;
}

.card-brand {
	grid-column: chip / card-brand;
	grid-row: card-brand / card-brand;
	grid-area: card-brand;
	height: 40px;
}

.card.back {
	position: relative;
}

.black-bar {
	background-color: #444;
	background-image: -webkit-linear-gradient(#444, #333);
	background-image: linear-gradient(#444, #333);
	width: 100%;
	height: 20%;
	position: absolute;
	top: 10%;
}

.securityCode {
	width: 50px;
	height: 30px;
	padding: 8px 0;

	line-height: 14px;
	text-align: center;
	font-style: italic;
	font-size: 18px;

	position: absolute;
	top: 40%;
	right: 5%;

	background: white;
	color: #414141;
}

</style>



// WEBPACK FOOTER //
// src/components/home/CreditCard.vue